import styled from 'styled-components';

export const TextBlockContainer = styled.div`
  display: grid;
  row-gap: 1.85em;
  align-self: center;
  grid-area: home-content;

    & > p {
        padding-right: 3em;
        @media all and (max-width: 900px) {
          padding-right: 0px;
        }
    }

    @media all and (max-width: 760px) {
      max-width: 440px;
      justify-self: center;
      h1, p {
        text-align: center;
      }
    }

`

export const TextBlockLinkContainer = styled.div`
    display: grid;
    column-gap: 2.1em;
    margin-top: 1.25rem;
    margin-bottom: 2rem;
    grid-template-columns: 1fr 300px;

    @media all and (max-width: 1360px) {
        grid-template-columns: 1fr 230px;
    }
    @media all and (max-width: 1282px) {
        grid-template-columns: 1fr 180px;
    }
    @media all and (max-width: 1220px) {
        grid-template-columns: 1fr;
        row-gap: 36px;
        max-width: 88%;
        margin-bottom: 0rem;

        button {
            justify-self: left;
            padding-left: 0px;
          }
        }

    @media all and (max-width: 960px) {
      max-width: 100%;
      button {
        justify-self: start;
      }
    }
    @media all and (max-width: 760px) {
      button {
        justify-self: center;
      }

      span {
        text-align: center;
      }
    }
  }
`;
